import { useState } from "react";
import { MenuTab } from "../components/MenuTab";
import { Bios } from "../types";

const BioMap = {
  skills: [
    "Javascript",
    "CSS",
    "HTML",
    "Typescript",
    "React",
    "React Native",
    "Node.js",
    "MongoDB",
    "NoSQL",
    "Unity",
  ],
  education: [
    "De Montfort University",
    "BSc Honors Computer Games Programming",
    "Game Engine Architecture",
    "Game Engine Development",
    "Advanced Shader Programming",
    "Robotics and AI",
    "2023 Complete Web Development Bootcamp",
    "React - The Complete Guide 2023",
  ],
  experience: [
    "Eighteen months worth of experience as a team lead of a small mobile app development team",
    "Five years of full stack development using React & React Native frameworks within the MERN tech stack",
    "Studied for a BSc (Hons) in Computer Games Programming at De Montfort University for three years, graduating with First-Class Honours.",
  ],
};

export const Skills = () => {
  const [activeBio, setActiveBio] = useState<Bios>("skills");

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-4 md:gap-6 justify-center lg:justify-start pb-8">
        <MenuTab
          header={"Skills"}
          onClick={() => setActiveBio("skills")}
          currentTab={activeBio}
        />
        <MenuTab
          header={"Education"}
          onClick={() => setActiveBio("education")}
          currentTab={activeBio}
        />
        <MenuTab
          header={"Experience"}
          onClick={() => setActiveBio("experience")}
          currentTab={activeBio}
        />
      </div>
      <div className="min-h-[14rem] text-left">
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-4">
          {BioMap[activeBio].map((bio, idx) => (
            <li
              key={idx}
              className={`flex items-start gap-3 p-4 rounded-xl border border-gray-800/50 bg-gray-900/30 transition-all duration-200 hover:border-gray-700 hover:bg-gray-800/40 ${
                activeBio === "experience" ? "md:col-span-2" : ""
              }`}
            >
              <div className="mt-2 w-1.5 h-1.5 rounded-full bg-violet-400/50 shrink-0" />
              <span className="text-gray-300 text-sm md:text-base leading-relaxed">
                {bio}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
